var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5703_2059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 18.2083C6 19.2625 6.9 20.125 8 20.125H16C17.1 20.125 18 19.2625 18 18.2083V6.70833H6V18.2083ZM8.46 11.385L9.87 10.0338L12 12.0654L14.12 10.0338L15.53 11.385L13.41 13.4167L15.53 15.4483L14.12 16.7996L12 14.7679L9.88 16.7996L8.47 15.4483L10.59 13.4167L8.46 11.385ZM15.5 3.83333L14.5 2.875H9.5L8.5 3.83333H5V5.75H19V3.83333H15.5Z",
    fill: "#FF8C8C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5703_2059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.6c2ac359cb73e2013608cfcf0e3bc4a3.svg";
export { ForwardRef as ReactComponent };